const notifications = {
  paymentError: "Zahlung fehlgeschlagen.",
  paymentSuccess: "Zahlung erfolgreich!",
  paymentAlreadyDone: "Zahlung bereits erfolgt.",
  alreadySubscribed: "Sie sind bereits abonniert.",
  passwordChanged: "Passwort erfolgreich geändert!",
  errorChangingPassword: "Fehler beim Ändern des Passworts!",
  invalidOldPassword: "Das alte Passwort ist ungültig.",
  passwordConfirmationDontMatch:
    "Neues Passwort und Bestätigung stimmen nicht überein.",
  emailExists:
    "Diese E-Mail ist bereits mit einem aktiven iizenglish-Konto verknüpft.",
  validationMailResent: "Bestätigungs-E-Mail erneut gesendet!",
  signupError:
    "Bei Ihrer Registrierung ist ein Fehler aufgetreten. Bitte wenden Sie sich an einen Administrator.",
  loginError:
    "Bei Ihrer Anmeldung ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator der Anwendung.",
  loginNotAllowed:
    "Sie sind nicht berechtigt, sich über diese Schnittstelle anzumelden.",
  errorCheckEmail:
    "Es ist ein Fehler aufgetreten. Bitte überprüfen Sie Ihre E-Mail-Adresse.",
  errorValidatingEmail:
    "Beim Bestätigen Ihrer E-Mail-Adresse ist ein Fehler aufgetreten.",
  setPasswordError:
    "Bei der Erstellung Ihres Passworts ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Administrator der Anwendung.",
  mailValidated: "E-Mail-Adresse bestätigt, Sie können sich nun anmelden!",
  mailValidationTokenNotFound: "Dieser Bestätigungslink ist nicht mehr gültig.",
  emailOrPasswordWrong: "Die E-Mail-Adresse oder das Passwort ist falsch.",
  forgotPasswordError:
    "Fehler bei der Anforderung zur Zurücksetzung des Passworts!",
  tokenExpired: "Token abgelaufen!",
  tokenExpiredText:
    "Die Anfrage für ein neues Passwort ist abgelaufen. Bitte erneut anfordern.",
  linkExpired: "Link expired!",
  badLink: "Der Link ist ungültig!",
  anErrorOccurred: "Es ist ein Fehler aufgetreten.",
  checkCSV: "Bitte überprüfen Sie Ihre CSV-Datei.",
  ifDontUnderstandImportError:
    "Wenn Sie nicht wissen, woher der Fehler kommt, senden Sie bitte Ihre CSV-Datei zusammen mit dem untenstehenden Inhalt an das Entwicklungsteam.",
  bugs: {
    reportSuccess:
      "Fehlerbericht erfolgreich gesendet. Vielen Dank für Ihren Beitrag.",
    reportFailure:
      "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
    serviceUnavailable:
      "Der Fehlerbericht ist momentan nicht verfügbar. Bitte versuchen Sie es später erneut, nachdem Sie die Seite neu geladen haben.",
  },
  class: {
    creationSuccess: "Klasse gespeichert.",
    creationFailure: "Fehler bei der Erstellung.",
    creationFailure400:
      "Klasse konnte nicht gespeichert werden, bitte Fehler korrigieren.",
    creationFailure409:
      "Klasse konnte nicht gespeichert werden – sie existiert bereits in dieser Schule.",
    editionFailure: "Fehler beim Bearbeiten der Klasse.",
    editionFailure400:
      "Klasse konnte nicht gespeichert werden, bitte Fehler korrigieren.",
    getClassesError:
      "Beim Laden der Klassen ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Administrator der Anwendung.",
    getClassError:
      "Beim Laden der Klasse ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Administrator der Anwendung.",
    teacherAlreadyInClassError: "Sie sind bereits Lehrkraft dieser Klasse!",
    teacherJoinsClassSuccess:
      "Sie sind jetzt Lehrkraft dieser Klasse. Sie finden sie unter „Meine Klassen verfolgen“.",
    deletionSuccess: "Die Klasse wurde erfolgreich gelöscht.",
    deletionFailure:
      "Beim Löschen der Klasse ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator der Anwendung.",
    tooFewLinesInClass: "Die Klasse muss mindestens einen Schüler enthalten.",
  },
  schools: {
    getSchoolsError:
      "Beim Laden der Einrichtungen ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator der Anwendung.",
    getSchoolError:
      "Beim Abrufen der Einrichtung ist ein Fehler aufgetreten. Bitte kontaktieren Sie Ihren Administrator.",
    purgeSuccess: "Daten erfolgreich bereinigt!",
    purgeError:
      "Beim Löschen der ausgewählten Schulen ist ein Fehler aufgetreten. Bitte kontaktieren Sie einen Administrator.",
    updateSchoolError:
      "Beim Aktualisieren der Schule ist ein Fehler aufgetreten.",
    updateSchoolSuccess: "Schule erfolgreich aktualisiert.",
    createSchoolSuccess: "Schule erfolgreich erstellt.",
    createSchoolError: "Beim Erstellen der Schule ist ein Fehler aufgetreten.",
    createSchoolAlreadyExistError: "Die Schule existiert bereits.",
  },
  students: {
    getStudentsError:
      "Beim Laden der Schüler ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator der Anwendung.",
    getStudentError:
      "Beim Abrufen des Schülers ist ein Fehler aufgetreten. Bitte kontaktieren Sie Ihren Administrator.",
    missingPasswordForActivation:
      "Ein Passwort ist erforderlich, um das Konto zu aktivieren.",
    createStudentSuccess: "Schüler erfolgreich erstellt.",
    updateStudentSuccess: "Schüler erfolgreich aktualisiert.",
    createStudentError:
      "Beim Erstellen des Schülers ist ein Fehler aufgetreten.",
    updateStudentError:
      "Beim Aktualisieren des Schülers ist ein Fehler aufgetreten.",
    deleteStudentSuccess: "Schüler erfolgreich aus der Klasse entfernt.",
    studentUnauthorizedToAccessHomework:
      "Sie sind nicht berechtigt, auf diese Aufgabe zuzugreifen.",
  },
  blogs: {
    getBlogsError:
      "Beim Laden der Blogbeiträge ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator der Anwendung.",
    getBlogError:
      "Beim Abrufen des Blogbeitrags ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator der Anwendung.",
    getBlogImageError:
      "Beim Abrufen der Bilder für die Blogbeiträge ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator der Anwendung.",
  },
  countries: {
    getCountriesError:
      "Beim Laden der Länder ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator der Anwendung.",
    getCountryError:
      "Beim Abrufen des Landes ist ein Fehler aufgetreten. Bitte kontaktieren Sie einen Administrator.",
    updateCountrySuccess: "Land erfolgreich aktualisiert.",
    createCountrySuccess: "Land erfolgreich erstellt.",
    updateCountryError:
      "Beim Aktualisieren des Landes ist ein Fehler aufgetreten.",
    createCountryError: "Beim Erstellen des Landes ist ein Fehler aufgetreten.",
  },
  homework: {
    creationSuccess: "Aufgabe erfolgreich gespeichert.",
    creationFailure: "Beim Erstellen der Aufgabe ist ein Fehler aufgetreten.",
    updateSuccess: "Aufgabe erfolgreich aktualisiert.",
    updateFailure: "Beim Aktualisieren der Aufgabe ist ein Fehler aufgetreten.",
    checkSubscriptionFailure:
      "Beim Laden der Seite zur Erstellung einer Aufgabe ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator der Anwendung.",
    expired: "Die Abgabefrist ist abgelaufen.",
    alreadyStarted:
      "Der Veröffentlichungsstatus kann nicht geändert werden, da mindestens ein Schüler diese Aufgabe bereits begonnen hat.",
    cannotDeletePublishedHomework:
      "Veröffentlichte Aufgaben können nicht gelöscht werden.",
    cannotUpdatePublishedHomework:
      "Veröffentlichte Aufgaben können nicht bearbeitet werden.",
    getHomeworkError:
      "Beim Laden der Aufgabe ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator der Anwendung.",
    retrieveHomeworksError:
      "Beim Abrufen Ihrer Aufgaben ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator der Anwendung.",
    saveHomeworkError:
      "Beim Speichern Ihrer Aufgabe ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator der Anwendung.",
    deleteHomeworkSuccess: "Aufgabe erfolgreich gelöscht.",
    deleteHomeworkError:
      "Beim Löschen der Aufgabe ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator der Anwendung.",
    endTimer:
      "Ihre Aufgabe endet in einer Minute. Bitte senden Sie Ihre Antworten ab.",
    noExerciseInHomework:
      "Diese Aufgabe enthält derzeit keine Übungen. Bitte kontaktieren Sie Ihren Lehrer.",
    gradeUnfinishedHomeworkSuccess:
      "Nicht abgeschlossene Aufgaben wurden erfolgreich bewertet. Die angezeigten Daten wurden aktualisiert.",
    mismatchedHomeworkData:
      "Diese Aufgabe wurde bereits bearbeitet und bewertet. Sie können sie erneut durchführen, wenn sie noch geöffnet ist.",
  },
  exercise: {
    saveSuccess: "Übung erfolgreich gespeichert.",
    saveFailure: "Beim Speichern der Übung ist ein Fehler aufgetreten.",
    getExercisesContentsError:
      "Beim Laden der Übungsübersicht ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator der Anwendung.",
    getExercisesError:
      "Beim Laden der Übungen ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator der Anwendung.",
    getExerciseError:
      "Beim Laden der Übung ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Administrator der Anwendung.",
    getExerciseNotFound:
      "Die Übung existiert nicht oder ist nicht verfügbar. Bitte kontaktieren Sie den Administrator der Anwendung.",
    incompleteExercise: "Die Übung ist unvollständig.",
  },
  blog: {
    saveSuccess: "Blogbeitrag erfolgreich gespeichert.",
    saveFailure: "Beim Speichern der Blog-Notiz ist ein Fehler aufgetreten.",
    imageFailure:
      "Das Bild ist zu groß. Bitte wählen Sie ein kleineres Bild (maximale Größe: 1 MB).",
    updateSuccess: "Blog-Notiz aktualisiert.",
    updateFailure:
      "Beim Aktualisieren des Blogbeitrags ist ein Fehler aufgetreten.",
    deleteSuccess: "Blogbeitrag erfolgreich gelöscht.",
    deleteFailure: "Beim Löschen des Blogbeitrags ist ein Fehler aufgetreten.",
    completedInAllLanguages:
      "Die Felder Titel, Schlüsselwörter und Beschreibung müssen in allen Sprachen ausgefüllt werden.",
  },
  user: {
    loginTimeout: "Ihre Sitzung ist abgelaufen.",
    editionSuccess: "Ihr Profil wurde gespeichert.",
    editionFailure: "Beim Speichern Ihres Profils ist ein Fehler aufgetreten.",
    deleteSuccess:
      "Ihr Konto wurde erfolgreich gelöscht. Bis bald auf iizenglish!",
    loadingDataError:
      "Beim Initialisieren Ihrer Sitzung ist ein Fehler aufgetreten.",
    sessionLost:
      "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an, um fortzufahren.",
  },
  account: {
    deleteSuccess: "Das Konto wurde erfolgreich gelöscht.",
    deleteFailure: "Beim Löschen des Kontos ist ein Fehler aufgetreten.",
    accountActivated: "Konto aktiviert.",
    accountNotActivated: "Konto nicht aktiviert.",
    accountDoesNotExists: "Mit dieser E-Mail-Adresse ist kein Konto verknüpft.",
    pendingAccountExists:
      "Für diese E-Mail-Adresse besteht bereits ein Konto, das auf Bestätigung wartet.",
  },
  garSubscriptions: {
    getSubscripionsError:
      "Beim Abrufen der GAR-Abonnements ist ein Fehler aufgetreten.",
    getSubscripionError:
      "Beim Abrufen des GAR-Abonnements ist ein Fehler aufgetreten.",
    getEstablishmentsError:
      "Beim Abrufen der GAR-Schulen ist ein Fehler aufgetreten.",
    createSubscripionError:
      "Beim Erstellen des Abonnements ist ein Fehler aufgetreten.",
    createSubscripionSuccess: "GAR-Abonnement erfolgreich erstellt!",
    updateSubscripionError:
      "Beim Aktualisieren des Abonnements ist ein Fehler aufgetreten.",
    updateSubscripionSuccess: "GAR-Abonnement erfolgreich aktualisiert!",
    deleteSubscripionSuccess: "Das Abonnement wurde erfolgreich gelöscht.",
    deleteSubscripionError:
      "Beim Löschen des Abonnements ist ein Fehler aufgetreten.",
  },
  teachers: {
    getTeacherStudentsError:
      "Beim Abrufen Ihrer Schüler ist ein Fehler aufgetreten.",
    getTeacherSchoolsError:
      "Beim Abrufen Ihrer Schulen ist ein Fehler aufgetreten.",
    retrieveTeachersError:
      "Beim Abrufen der Lehrkräfte ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Administrator der Anwendung.",
    updateTeacherSuccess: "Lehrkraft erfolgreich aktualisiert",
    updateTeacherEmailError:
      "Diese E-Mail-Adresse wird bereits verwendet. Die Lehrkraft konnte nicht aktualisiert werden",
    updateTeacherPasswordError:
      "Für die Aktivierung ist ein Passwort erforderlich.",
    createTeacherSuccess: "Lehrkraft erfolgreich erstellt",
    createTeacherError:
      "Beim Erstellen der Lehrkraft ist ein Fehler aufgetreten",
    createTeacherPasswordError:
      "Zur Aktivierung des Kontos ist ein Passwort erforderlich.",
    createTeacherEmailError:
      "Diese E-Mail-Adresse wird bereits verwendet. Die Lehrkraft konnte nicht erstellt werden.",
  },
  fieldsError: "Einige Felder enthalten Fehler.",
  sendReminderSuccess: "Erinnerung gesendet.",
  sendReminderError:
    "Beim Senden der Erinnerung ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Administrator der Anwendung.",
  emptyAnswer: "Das Antwortfeld ist leer.",
  emptyAnswerRemaining: "Mindestens eine Antwort ist noch leer.",
  incompleteHomework: "Die Aufgabe ist unvollständig.",
  noAnswerSelected: "Keine Antwort ausgewählt.",
  noAnswerMoved: "Keine Antworten verschoben.",
  clickAgainToValidate:
    "Klicken Sie erneut auf die Schaltfläche, wenn Sie trotzdem bestätigen möchten.",
  clickAgainToGoBack:
    "Sie haben nicht gespeicherte Änderungen. Klicken Sie erneut auf die Schaltfläche „Zurück“, wenn Sie die Seite ohne Speichern verlassen möchten.",
  clickAgainToGoToExercise:
    "Klicken Sie erneut auf die Schaltfläche, wenn Sie die Übung trotzdem wechseln möchten. Nicht gespeicherte Daten gehen verloren.",
  clickAgainToFinish:
    "Klicken Sie erneut auf die Schaltfläche, wenn Sie die Aufgabe trotzdem beenden möchten.",
  tableofcontentResetSuccess: "Übersicht zurückgesetzt!",
  tableofcontentResetError:
    "Beim Zurücksetzen der Übersicht ist ein Fehler aufgetreten.",
  errorOccuredUpdating:
    "Beim Aktualisieren der Informationen ist ein Fehler aufgetreten. Bitte wenden Sie sich an einen Administrator.",
  resources: {
    getResourcesError:
      "Beim Abrufen der Ressourcen ist ein Fehler aufgetreten. Bitte wenden Sie sich an einen Administrator.",
    updateDescriptionError:
      "Beim Aktualisieren der Beschreibung ist ein Fehler aufgetreten. Bitte wenden Sie sich an einen Administrator.",
  },
  messageDontMatch: "Die Nachricht stimmt nicht überein.",
  twoFactorAuth: {
    incorrectCode: "Ungültiger Code.",
    expiredCode:
      "Der Bestätigungscode ist abgelaufen. Bitte fordern Sie einen neuen an.",
    validationError:
      "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    newRequestSent:
      "Wir haben einen neuen Bestätigungscode an Ihre E-Mail-Adresse gesendet.",
  },
  missingStudentsLevelPart1:
    "Einige Schüler, die dieser Aufgabe zugewiesen sind, haben kein Niveau festgelegt. Klicken Sie erneut auf die Schaltfläche, um fortzufahren.",
  missingStudentsLevelPart2: "um fortzufahren",
  subscriptions: {
    updateHideReminderError:
      "Beim Aktualisieren Ihrer Abonnement-Einstellungen ist ein Fehler aufgetreten. Bitte wenden Sie sich an einen Administrator.",
  },
  mockExams: {
    importSuccess: "Probeklausuren erfolgreich importiert!",
    importError: "Beim Import ist ein Fehler aufgetreten.",
    getMockExamsTableOfContentsError:
      "Die Übersicht der Probeklausuren konnte nicht geladen werden. Bitte wenden Sie sich an den Administrator.",
    getMockExamError:
      "Die Probeklausur konnte nicht geladen werden. Bitte wenden Sie sich an den Administrator.",
  },
  globalParameters: {
    updateValueError:
      "Beim Aktualisieren der Einstellung ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Administrator der Anwendung.",
    updateValueSuccess: "Die Einstellung wurde erfolgreich aktualisiert.",
    resetValueSuccess: "Die Einstellung wurde erfolgreich zurückgesetzt.",
    listError:
      "Beim Abrufen der Einstellungen ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Administrator der Anwendung.",
    simplifiedListError:
      "Beim Laden der Anwendung ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut oder wenden Sie sich an den Administrator der Anwendung.",
  },
};

export default notifications;
